import { createAction } from 'redux-actions';

export const setLogin = createAction('SET_LOGIN');
export const logout = createAction('LOGOUT');
export const getDownloadUrl = createAction('GET_DOWNLOAD');
export const setCustomerAdmins = createAction('SET_CUSTOMER_ADMINS');
export const setIsAutoLogin = createAction('SET_IS_AUTO_LOGIN');
export const saveGridHeader = createAction('SAVE_GRID_HEADER');
export const saveGridContent = createAction('SAVE_GRID_CONTENT');
export const setIdCustomer = createAction('SET_ID_CUSTOMER');
